import type { QuestionCore } from "../contracts";
import { defaultThemeV2 } from "../../theme/defaultThemeV2";

export type EmbedRaw = {
  type: "embed";
  content: string;
  embed_code: string;
  number_seconds: number;
  auto_response?: string | null;
};

export type EmbedDefinition = {
  prompt: string;
  embedCode: string;
  numberSeconds: number;
};

export type EmbedDraft = Record<string, never>;
export type EmbedEvent = { type: "acknowledge" };
export type EmbedResponse = { type: "embed"; value: "Video viewed" };

export const embedCore: QuestionCore<
  EmbedRaw,
  EmbedDefinition,
  EmbedDraft,
  EmbedEvent,
  EmbedResponse
> = {
  decode: (raw) => {
    if (typeof raw.embed_code !== "string" || !raw.embed_code.trim()) {
      throw new Error("Embed question requires iframe content.");
    }
    return {
      prompt: raw.content,
      embedCode: raw.embed_code,
      numberSeconds: raw.number_seconds,
    };
  },
  initialize: () => ({}),
  update: (_definition, draft) => draft,
  validate: () => ({ valid: true }),
  encode: () => ({ type: "embed", value: "Video viewed" }),
  projectTranscript: (definition, _draft, copy = defaultThemeV2.copy) => ({
    kind: "embed",
    question: definition.prompt,
    answer: copy.actions.acknowledge,
  }),
};
